<template>
    <div id="main">
        <div class="listing-header">
          <div class="title-breadcrumb">
            <h1 class="title">{{ parametrizacao['label-tabela-usuario'] }}</h1>
          </div>
          <div class="header-buttons">
            <button class="delete-btn" type="button" tag="button" @click="fechar()">
              {{ $t('fechar') }}
            </button>
          </div>
        </div>
        <section class="video">
            <iframe allow="autoplay" :src="parametrizacao.video_url_parametrizacao" :title="parametrizacao.label"></iframe>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        parametrizacao: {}
    },
    methods: {
        fechar() {
            this.$emit('fecharModal', 'video');
        }
    }
}
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px !important;

    // essa solução encontrei nesse link
    // https://stackoverflow.com/questions/52393814/css-100-width-of-youtube-embed-video
    .video {
        --video--width: 1296;
        --video--height: 540;

        position: relative;
        padding-bottom: calc(var(--video--height) / var(--video--width) * 100%);
        overflow: hidden;
        max-width: 100%;
        background: black;
        margin-top: 10px;

        iframe, object, embed {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
}
</style>